import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class ProcessoUtilizacaoApiClient {
	URL_PATH = 'api/processosUtilizacao'

	async buscarOrgaos() {
		return await axios.get(`${this.URL_PATH}/orgaos`)
	}

	async buscarPorFiltro(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.URL_PATH,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async buscarUrlProcessoUtilizacaoLegado({ idProcessoUtilizacao, idUnidadeOrganizacional }) {
		return await axios.get(`api/comprasLegado/processoUtilizacao/url`, {
			headers: {
				idProcessoUtilizacao: idProcessoUtilizacao,
				idUnidadeOrganizacional: idUnidadeOrganizacional,
			},
		})
	}
}

export default new ProcessoUtilizacaoApiClient()
